import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import styles from './ProposalScreen.module.scss'
import ButtonCustom from '../atoms/button/ButtonCustom'
import BidDetailsCard from '../atoms/BidDetailsCard/BidDetailsCard'
import StatusBtn from '../atoms/status/StatusBtn'

import VendorWeddingInfo from '../VendorWeddingInfo/VendorWeddingInfo'
import { getAllProposals } from '../../features/proposalSlice'
import { formatCommonDate } from '../../util/formatDateAndTime'

import Reject from './modal/Reject'
import Review from './modal/Review'
import { getPackages } from '../../features/packageSlice'
import { formatPackageData } from './modal/reviewLineItemTree'

function ProposalScreen() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { proposalId } = useParams()
	const [modal, setModal] = useState('')
	const [isEdit, setIsEdit] = useState(false)
	const proposals = useSelector((s) => s.proposal.proposals) || []
	const vendorId = useSelector((state) => state.auth.user?._id)

	const proposal =
		proposals.find((p) => String(p.proposalId) === String(proposalId)) ||
		null

	const categoryBudget = proposal?.categoryBudget ?? 0

	const statusLabel = proposal?.status || 'Submitted'
	const statusVariant =
		statusLabel === 'Approved'
			? 'completed'
			: statusLabel === 'Submitted'
				? 'submitted'
				: ['Declined', 'Rejected'].includes(statusLabel)
					? 'error'
					: 'default'

	const formattedProposal = useMemo(() => {
		const rawTotal = proposal?.total
		const rawTax = proposal?.tax
		const rawSubTotal = proposal?.subTotal
		if (!proposal?.packageDetail)
			return { ...proposal, rawTotal, rawTax, rawSubTotal }
		const linePackages = proposal?.lineItems?.map((item) =>
			formatPackageData(item)
		)
		const pkg = {
			tax: 0,
			total: 0,
			packages: [],
			grandTotal: 0,
			taxPercentage: 0,
		}
		linePackages?.forEach((item) => {
			pkg.tax += item.tax
			pkg.total += item.total
			pkg.grandTotal += item.grandTotal
			pkg.packages.push(...item.packages)
			pkg.taxPercentage = item.taxPercentage
		})
		// const formattedPackageData = formatPackageData(proposal?.packageDetail)
		return {
			...proposal,
			...pkg,
			rawTotal,
			rawTax,
			rawSubTotal,
		}
	}, [proposal])

	useEffect(() => {
		dispatch(getAllProposals({ proposalId }))
		dispatch(getPackages({ vendorId }))
	}, [dispatch])

	const closeModal = () => setModal('')

	const editBid = () => {
		setIsEdit(true)
		setModal('review')
	}

	return (
		<>
			<div className={styles.ProposalScreen}>
				<div className={styles.ProposalScreenHeader}>
					<button
						className={styles.backBtn}
						onClick={() =>
							navigate(
								proposal?.status === 'New'
									? -1
									: '/vendor-proposal?tab=my-bids'
							)
						}
					>
						<img src="/images/BackButton.svg" alt="BackButton" />
						Back
					</button>
					<div className={styles.statusBtn}>
						<StatusBtn
							label={statusLabel}
							variant={statusVariant}
						/>
					</div>
				</div>

				<VendorWeddingInfo
					editBid={editBid}
					kazooId={proposal?.kazooId}
					proposalData={formattedProposal}
					categoryBudget={categoryBudget}
				/>

				{statusLabel === 'New' ? (
					<div className={styles.ProposalScreenCardBottom}>
						<p>
							Last Updated:{' '}
							{formatCommonDate(proposal?.updatedAt, true)}
						</p>
						<div style={{ display: 'flex', gap: '10px' }}>
							<ButtonCustom
								onClick={() => setModal('reject')}
								variant="destructive"
							>
								Reject
							</ButtonCustom>
							<ButtonCustom
								onClick={() => {
									setIsEdit(false)
									setModal('review')
								}}
								variant="approve"
							>
								Review
							</ButtonCustom>
						</div>
					</div>
				) : (
					<div>
						{/* Bid details + footer row */}
						{/* <BidDetailsCard data={formattedProposal} /> */}
					</div>
				)}

				{modal === 'reject' ? (
					<Reject clickHandler={closeModal} data={proposalId} />
				) : modal === 'review' ? (
					<Review
						isEdit={isEdit}
						clickHandler={closeModal}
						data={formattedProposal}
					/>
				) : null}
			</div>
		</>
	)
}

export default ProposalScreen
